import { JSX } from 'react';

import { useStyles } from './principles-section.styles';
import { ContentWrapper } from '../../../common/content-wrapper';
import { SectionTitle } from '../../../common/section-title';
import { CardsList } from './cards';
import { principlesItems } from './principles.items';
import { SectionLabels } from '../../../../constants/common-constants';

export const PrinciplesSection = (): JSX.Element => {
  const classes = useStyles();
  const id = SectionLabels.principles;

  return (
    <section
      className={classes.root}
      data-testid="principles"
      aria-labelledby={id}
    >
      <ContentWrapper externalStyles={classes.content}>
        <SectionTitle
          id={id}
          isLight
          colorPart="principles.title-1"
          title="principles.title-2"
          content="principles.content"
        />
        <CardsList cards={principlesItems} />
      </ContentWrapper>
    </section>
  );
};
